module.exports = __webpack_public_path__ + "img/hard.f338049e.png";